<template>
  <div class="appointment_main">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          :picker-options="pickerOptions2"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <!--<button-delete @deleteSelection="deleteSelection" :value="'删除'" style="margin-left: 10px;" />-->
        <button-confirm-next value="经纪人申请" @confirm="showWindowLeftBox" style="margin-left: 10px;" v-if="permissionCodes.indexOf('017002002') !== -1"/>
      </div>
      <input-search placeholder="经纪人姓名/经纪人手机" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @changeSelection="changeSelection" @deleteLine="deleteLine" @lookOver="lookOver" :deleteTipInfo="'是否确认删除该经纪人？'" :operationArr="operationArr" />

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImg" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">

            <div class="search-line" style="margin: 10px 0">
              <div class="btn-box">

              </div>
              <input-search placeholder="姓名/手机号" @search="windowLeftSearch"/>
            </div>
            <div>
              <table-main :selection="false" :tableHead="windowLeftTableHead" :tableData="windowLeftTableData" :total="windowLeftTotal" :pageNum="windowLeftPageNum" :pageSize="windowLeftPageSize" :hasOperation="false" @changePagination="changeWindowLeftPagination" :row-click="windowLeftRowClick" />
            </div>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>

    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      size="60%"
      :before-close="handleClose">
      <div class="person-management-drawer">
        <button @click="personDataToWindowLeft" class="el-icon-back"></button>
        <form>
          <img class="drawerPersonImg" :src="drawerPersonData.picUrl" alt="" v-if="drawerPersonData.visitorPic">
          <p class="noDrawerPersonImg" v-else>暂无人员照片</p>
          <div class="form-line">
            <div class="line-text">
              <div>经</div>
              <div>纪</div>
              <div>人</div>
              <div>姓</div>
              <div>名：</div>
            </div>
            <div>{{drawerPersonData.name || '无'}}</div>
          </div>

          <div class="form-line">
            <div class="line-text">
              <div>经</div>
              <div>纪</div>
              <div>人</div>
              <div>手</div>
              <div>机</div>
              <div>号：</div>
            </div>
            <div>{{drawerPersonData.phone || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>经</div>
              <div>纪</div>
              <div>人</div>
              <div>公</div>
              <div>司：</div>
            </div>
            <div>{{drawerPersonData.enterpriseName || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>所</div>
              <div>在</div>
              <div>区</div>
              <div>域：</div>
            </div>
            <div>{{drawerPersonData.areaInfo || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>主</div>
              <div>营</div>
              <div>商</div>
              <div>圈：</div>
            </div>
            <div>{{drawerPersonData.primaryArea || '无'}}</div>
          </div>
          <div class="form-line">
            <div class="line-text">
              <div>微</div>
              <div>信</div>
              <div>号：</div>
            </div>
            <div>{{drawerPersonData.weChatNumber || '无'}}</div>
          </div>
        </form>
        <div class="drawerBtnBox">
          <el-button size="small" class="btn-confirm"  @click="confirmApprove()">同意</el-button>
          <el-button size="small" class="reject-button"  @click="rejectApprove()" >驳回</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/agent'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      ButtonConfirmNext,
      TableMain,
      InputSearch,
      Breadcrumb},
    name: 'agent-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧经纪',
          name: 'investment-manage'
        }, {
          value: '经纪人管理'
        }],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'name',
          label: '经纪人姓名',
          width: '120px',
        }, {
          prop: 'phone',
          label: '经纪人手机号',
          width: '120px',
        }, {
          prop: 'enterpriseName',
          label: '经纪人住户'
        }, {
          prop: 'areaInfo',
          label: '所在区域'
        }, {
          prop: 'primaryArea',
          label: '主营商圈'
        }, {
          prop: 'weChatNumber',
          label: '微信号'
        },{
          prop: 'personPic',
          label: '经纪人头像',
          isLookOver: true,
          width: '120px',
        }, {
          prop: 'addingTime',
          label: '加入时间'
        }],
        tableData: [],
        operationArr: ['delete'],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        timeValue: [],
        requestData: {
          pageNum: 1,
          pageSize: 10,
          startTime: '',
          endTime: '',
          searchKey: ''
        },
        visitorVisible: false,
        lookOverImg: '',
        dialogVisible: false,

        windowLeftBox: false,
        windowLeftTableHead: [{
          prop: 'name',
          label: '经纪人姓名'
        }, {
          prop: 'phone',
          label: '经纪人手机号'
        }, {
          prop: 'enterpriseName',
          label: '经纪人住户'
        }, {
          prop: 'areaInfo',
          label: '所在区域'
        }, {
          prop: 'primaryArea',
          label: '主营商圈'
        }, {
          prop: 'weChatNumber',
          label: '微信号'
        }, {
          prop: 'picUrl',
          label: '经纪人头像',
          isLookOver: true
        }],
        windowLeftTableData: [],
        windowLeftSearchKey: '',
        windowLeftTotal: 0,
        windowLeftPageNum: 1,
        windowLeftPageSize: 10,
        drawer: false,
        drawerPersonData: {},

        selectionArr: []
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getCreatTime()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getCreatTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.timeValue[0] = year + '-' + month + '-01'
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        if (this.timeValue.length > 0) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`
          reqData.endTime = `${this.timeValue[1]} 23:59:59`
        }
        this.$axios.post(api.getPageAgentPerson, reqData)
          .then(res => {
            let list = res.data.data.list
            this.total = res.data.data.total
            list.map(v => {
              v.picUrl = v.personPic
              v.areaInfo = `${v.province}${v.city}${v.region}`
            })
            this.tableData = list
          })
          .catch(errorHandler('获取失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },

      lookOver (imgUrl) {
        this.lookOverImg = imgUrl
        this.dialogVisible = true
      },

      changeWindowLeftPagination (data) {
        this.windowLeftPageNum = data[0]
        this.windowLeftPageSize = data[1]
        this.getPageApply()
      },

      // 展示人员申请
      showWindowLeftBox () {
        this.windowLeftBox = true
        this.getPageApply()
      },

      // 返回
      personDataToWindowLeft () {
        this.drawer = false
        this.windowLeftBox = true
      },

      // 点击人员查看详情
      windowLeftRowClick (row, event, column) {
        this.windowLeftBox = false
        this.drawer = true
        this.drawerPersonData = row
        // this.getPersonBaklogByCode(row.baklogCode)
      },

      windowLeftSearch (v) {
        this.windowLeftPageNum = 1
        this.windowLeftSearchKey = v
        this.getPageApply()
      },

      handleClose(done) {
        done()
        this.windowLeftBox = true
      },

      // 查询经纪人申请列表
      getPageApply () {
        this.$axios.post(api.getPageApply, {
          status: 'PENDING',
          pageNum: this.windowLeftPageNum,
          pageSize: this.windowLeftPageSize,
          searchKey: this.windowLeftSearchKey
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.code = v.recordCode
                v.picUrl = v.personPic
                v.areaInfo = `${v.province}${v.city}${v.region}`
              })
              this.windowLeftTotal = res.data.data.total
              this.windowLeftTableData = data
            }
          })
          .catch(errorHandler('获取申请列表失败'))
      },

      // 同意申请
      confirmApprove () {
        this.drawerPersonData.status = 'PASS'
        this.$axios.post(`${api.handleApply}`, this.drawerPersonData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.drawer = false
              this.windowLeftBox = true
              this.getPageApply()
              this.pageNum = 1
              this.requestData.searchKey = ''
              this.getPage()
            }
          })
          .catch(errorHandler('操作失败'))
      },

      // 驳回申请
      rejectApprove () {
        this.drawerPersonData.status = 'REJECT'
        this.$axios.post(`${api.handleApply}`, this.drawerPersonData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.drawer = false
              this.windowLeftBox = true
              this.getPageApply()
              this.pageNum = 1
              this.requestData.searchKey = ''
              this.getPage()
            }
          })
          .catch(errorHandler('操作失败'))
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      deleteSelection () {
        if (this.selectionArr.length === 0) {
          nAlert('请先选择需要删除的经纪人')
          return false
        } else {
          this.$confirm('是否确认删除所选中的经纪人？', '提示')
            .then(() => {
              this.deleteLine(this.selectionArr)
            })
            .catch(() => {
              console.log('取消删除')
            })
        }
      },
      deleteLine (code) {
        this.$axios.post(api.deleteAgent, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },
    },
    watch: {}
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .appointment_main {
    .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
      /*width: 50%!important;*/
    }

    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }

    form {
      width: 450px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
      width: 360px;
      padding-right: 60px;
      margin: 40px auto 0;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
  }

  .el-dialog__body {
    .el-table .cell{
      text-align: center;
    }
    .el-table th>.cell {
      color: #48576a;
      font-weight: bold;
    }
  }
  .el-dialog {
    .el-dialog .el-dialog__body .el-table__empty-block {
      margin: 0 auto;
    }
    .el-table__empty-text {
      width: auto;
    }
    .el-dialog__header {
      text-align: center
    }
    .el-dialog__body {
      .el-table th:first-child {
        width: auto!important;
      }
    }
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Agent/agentManage/agentManage.vue